import { render, staticRenderFns } from "./TechExpertRepairs.vue?vue&type=template&id=904d0816&scoped=true"
import script from "./TechExpertRepairs.vue?vue&type=script&lang=js"
export * from "./TechExpertRepairs.vue?vue&type=script&lang=js"
import style0 from "./TechExpertRepairs.vue?vue&type=style&index=0&id=904d0816&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904d0816",
  null
  
)

export default component.exports